var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "75px",
    viewBox: "0 0 70 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-check"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-37",
    fill: "#000000",
    cx: 35,
    cy: 35,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-38",
    fill: "#000000",
    cx: 35,
    cy: 40,
    r: 35
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-39",
    fill: "#FD6687",
    cx: 35,
    cy: 35,
    r: 32
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    points: "20 34.5819497 30.2640104 44.84596 50.1099704 25"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.09edb9dc6d34aac5a1b039e28520070b.svg";
export { ForwardRef as ReactComponent };